import { isDate as Nt } from "../../util/code-utils.js";
import {
  convertMsToSeconds as X,
  dateFromUnixTimestamp as V,
  secondsAgo as es,
  secondsInTheFuture as hs,
} from "../../util/date-utils.js";
export default class cr {
  constructor(t, s, e, i) {
    (this.yE = t),
      (this.HE = s),
      (this.comparator = e),
      (this.LE = i),
      (this.yE = t),
      (this.HE = s),
      (this.comparator = e),
      (this.LE = i),
      this.HE === cr.XE.QE &&
        this.comparator !== cr.BE.wE &&
        this.comparator !== cr.BE.jE &&
        this.comparator !== cr.BE.zE &&
        this.comparator !== cr.BE.FE &&
        (this.LE = V(this.LE));
  }
  sf(t) {
    let s = null;
    switch ((null != t && (s = t[this.yE]), this.comparator)) {
      case cr.BE.kE:
        return null != s && s.valueOf() === this.LE.valueOf();
      case cr.BE.xE:
        return null == s || s.valueOf() !== this.LE.valueOf();
      case cr.BE.JE:
        return null != s && typeof s == typeof this.LE && s > this.LE;
      case cr.BE.wE:
        return this.HE === cr.XE.QE
          ? null != s && Nt(s) && es(s) <= this.LE.valueOf()
          : null != s && typeof s == typeof this.LE && s >= this.LE;
      case cr.BE.VE:
        return null != s && typeof s == typeof this.LE && s < this.LE;
      case cr.BE.jE:
        return this.HE === cr.XE.QE
          ? null != s && Nt(s) && es(s) >= this.LE.valueOf()
          : null != s && typeof s == typeof this.LE && s <= this.LE;
      case cr.BE.qE:
        return (
          null != s &&
          "string" == typeof s &&
          typeof s == typeof this.LE &&
          null != s.match(this.LE)
        );
      case cr.BE.PE:
        return null != s;
      case cr.BE.WE:
        return null == s;
      case cr.BE.zE:
        return null != s && Nt(s) && hs(s) < this.LE;
      case cr.BE.FE:
        return null != s && Nt(s) && hs(s) > this.LE;
      case cr.BE.ZE:
        return (
          null == s ||
          typeof s != typeof this.LE ||
          "string" != typeof s ||
          null == s.match(this.LE)
        );
    }
    return !1;
  }
  static fromJson(t) {
    return new cr(
      t.property_key,
      t.property_type,
      t.comparator,
      t.property_value,
    );
  }
  gt() {
    let t = this.LE;
    return (
      Nt(this.LE) && (t = X(t.valueOf())),
      { k: this.yE, t: this.HE, c: this.comparator, v: t }
    );
  }
  static _u(t) {
    return new cr(t.k, t.t, t.c, t.v);
  }
}
(cr.XE = { $E: "boolean", tT: "number", sT: "string", QE: "date" }),
  (cr.BE = {
    kE: 1,
    xE: 2,
    JE: 3,
    wE: 4,
    VE: 5,
    jE: 6,
    qE: 10,
    PE: 11,
    WE: 12,
    zE: 15,
    FE: 16,
    ZE: 17,
  });
